import {ReactNode} from "react";
import {useSortable} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";
import DragHandleRoundedIcon from "@mui/icons-material/DragHandleRounded";

export const SortListItem = ({label, endAdornment, itemType}: {
  label: string,
  endAdornment?: ReactNode,
  itemType: 'category' | 'product'
}) => {
  return (
    <div className={`${itemType === 'product' ? 'ml-4' : 'ml-2'} my-2 flex flex-row items-center justify-between gap-3`}>
      <DragHandleRoundedIcon className={itemType === 'product' ? '' : 'text-material-primary'}/>
      <p className={`w-full ${itemType === 'product' ? '' : 'text-material-primary'}`}>
        {label}
      </p>
      {endAdornment}
    </div>
  )
}

export const Sortable = ({children, id}: {
  children: ReactNode,
  id: string,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({id});
  const style = {
    cursor: "move",
    listStyle: "none",
    transform: CSS.Transform.toString(transform),
    transition
  };
  return (
    <div ref={setNodeRef} {...attributes} {...listeners} style={style}>
      {children}
    </div>
  )
}
